import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import { uploadPersonPhoto } from 'reducers/FileReducer';
import Button from '@material-ui/core/Button';
import CameraIcon from '@material-ui/icons/Camera';
import { Camera } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SaveIcon from '@material-ui/icons/Save';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';
import { notify } from 'reducers/NotifierReducer';
import { handleError } from 'reducers/ErrorReducer';
import StopIcon from '@material-ui/icons/Stop';
import Dictionary from 'components/Dictionary';
import Checkbox2 from 'components/Checkbox2';
import formStyles, {
  gridStyle,
  Row,
  RowInner,
  ColCard,
  Fills,
  formatSaveData,
} from 'utils/formStyles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  camApp: {
    marginLeft: '50px',
    marginBottom: '100px',
  },
  item: gridStyle(200, 400),
  form: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  videoBtns: {
    marginTop: theme.spacing(9),
  },
}));

function WebcamPhoto(props) {
  const classes = useStyles();
  const { ptsPersonID, setCamOn } = props;
  const videoRef = useRef(null);
  const photoRef = useRef(null);
  const [hasPhoto, setHasPhoto] = useState(false);
  const [hasVideo, setHasVideo] = useState(false);
  const [Description, setDescription] = useState('');
  const [ImageTypeCode, setImageTypeCode] = useState(null);
  const [MarkType, setMarkType] = useState(null);
  const [Location, setLocation] = useState(null);
  const [Gang, setGang] = useState(null);
  const [IsMark, setIsMark] = useState(false);

  useEffect(() => {
    getVideo();
  }, [videoRef]);

  const getVideo = () => {
    setHasVideo(true);
    navigator.mediaDevices
      .getUserMedia({
        video: { width: 720, height: 480 },
      })
      .then((stream) => {
        let video = videoRef.current;
        video.srcObject = stream;
        video.play();
      })
      .catch((err) => {
        console.error(err);
        setHasVideo(false);
        setCamOn(false);
      });
  };

  const stopVideo = () => {
    const stream = videoRef.current.srcObject;
    stream.getVideoTracks()[0].stop();
    videoRef.current.srcObject = null;
    setHasVideo(false);
    setCamOn(false);
  };

  const takePhoto = () => {
    const width = 414;
    const height = width / (16 / 9);

    let video = videoRef.current;
    let photo = photoRef.current;

    photo.width = width;
    photo.height = height;

    let ctx = photo.getContext('2d');
    ctx.drawImage(video, 0, 0, width, height);
    setHasPhoto(true);
  };

  const clearPhoto = () => {
    let photo = photoRef.current;
    let ctx = photo.getContext('2d');
    ctx.clearRect(0, 0, photo.width, photo.height);
    setHasPhoto(false);
    clearForm();
  };

  const saveSnap = async () => {
    try {
      let photo = photoRef.current;
      photo.toBlob(async (blob) => {
        const saveObj = formatSaveData({
          ImageTypeCode,
          IsMark,
          Location,
          Gang,
          Description,
          MarkType,
        });
        saveObj.ptsPersonID = ptsPersonID;
        saveObj.file = blob;

        await uploadPersonPhoto(saveObj);
        props.notifyDataUpdate({ type: 'person-image-upload', data: {} });
        //props.notify('Snapshot Uploaded', 'success');
        clearPhoto();
      });
    } catch (err) {
      props.handleError(err);
    }
  };

  const clearForm = () => {
    setDescription('');
    setImageTypeCode(null);
    setMarkType(null);
    setLocation(null);
    setGang(null);
    setIsMark(false);
  };

  const renderInfoForm = () => {
    return (
      <div className={classes.form}>
        <Dictionary
          options="MugshotTypes"
          className={classes.item}
          onChange={(ev, val) => setImageTypeCode(val)}
          value={ImageTypeCode}
          label="Image Type"
          compact="true"
        />
        <Checkbox2
          checked={IsMark}
          onChange={() => setIsMark(!IsMark)}
          label="Scar, Mark, or Tattoo"
        />
        {IsMark && (
          <Row className="ml-1">
            <RowInner>
              <Dictionary
                options="Marks"
                className={classes.item}
                onChange={(ev, val) => setMarkType(val)}
                value={MarkType}
                label="Mark Type"
                compact="true"
              />
            </RowInner>
            <RowInner>
              <Dictionary
                options="TattooLocation"
                className={classes.item}
                onChange={(ev, val) => setLocation(val)}
                value={Location}
                label="Location"
                compact="true"
              />
            </RowInner>
            <RowInner>
              <Dictionary
                options="Gang"
                className={classes.item}
                onChange={(ev, val) => setGang(val)}
                value={Gang}
                label="Gang"
                compact="true"
              />
            </RowInner>
            <RowInner>
              <TextField
                label="Description"
                variant="outlined"
                size="small"
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
                className={classes.item}
              />
            </RowInner>
          </Row>
        )}
      </div>
    );
  };

  return (
    <div className={classes.camApp}>
      <Grid container>
        <Grid item sm={7}>
          <div className={classes.camera}>
            <div>
              <video ref={videoRef}></video>
            </div>
            {hasVideo && (
              <div className={classes.videoBtns}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={takePhoto}
                  className="mr-4">
                  <Camera className="mr-2" /> Take Snapshot
                </Button>
                <Button variant="contained" color="secondary" size="small" onClick={stopVideo}>
                  <StopIcon className="mr-2" /> Stop Live Feed
                </Button>
              </div>
            )}
          </div>
        </Grid>
        <Grid item sm={5}>
          <div>
            <div>
              <canvas ref={photoRef}></canvas>
            </div>
            {hasPhoto && (
              <>
                {renderInfoForm()}
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  className="mr-4"
                  onClick={saveSnap}>
                  <SaveIcon className="mr-2" /> Save Snapshot
                </Button>
                <Button variant="contained" color="secondary" size="small" onClick={clearPhoto}>
                  <ClearIcon className="mr-2" /> Clear Image
                </Button>
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default connect(null, {
  notify,
  handleError,
  notifyDataUpdate,
})(WebcamPhoto);
